import { pnlPct } from "./msiRiskManager";

export function buildClosedTrade(position) {
  const pnl = pnlPct(position);
  const now = new Date().toISOString();

  return {
    ...position,
    closed_at: now,
    stock_exit: position.stock_current ?? null,
    option_exit: position.option_current ?? null,

    days_open: position.days_open || 1,

    result: pnl >= 0 ? "WIN" : "LOSS",
    pnl_pct: Number(pnl.toFixed(1)),
    status: "CLOSED",
  };
}

export function closePosition(position, openPositions, closedPositions) {
  const closedTrade = buildClosedTrade(position);

  const nextOpen = openPositions.filter(
    (p) =>
      !(
        p.ticker === position.ticker &&
        p.contract === position.contract &&
        (p.opened_at || p.opened) === (position.opened_at || position.opened)
      )
  );

  const nextClosed = [closedTrade, ...closedPositions];

  localStorage.setItem("msi_open_positions", JSON.stringify(nextOpen));
  localStorage.setItem("msi_closed_positions", JSON.stringify(nextClosed));

  return {
    open: nextOpen,
    closed: nextClosed,
    closedTrade,
  };
}
